import { pxToRem } from '../../../../lib';
export default (function () {
  return {
    margin: pxToRem(8),
    gutterMargin: pxToRem(10),
    messageMargin: pxToRem(40)
  };
});